import React from 'react';
import styles from './RiskIndicatorCard.module.scss';
import { EMPTY_NAME_PLACEHOLDER, RISK_HEADERS } from './RiskIndicatorConstants';
import { useRiskIndicatorStates } from './useRiskIndicatorStates';
import { legalCasesDotState } from './riskIndicatorUtils';
import type { RegulatoryRiskCell } from './RiskIndicators';

// Narrower than the exported Row on purpose — this card only needs these fields. The cell
// shape is imported rather than restated so it cannot drift from the wire contract; `import
// type` is erased at compile time, so it does not create a runtime cycle with RiskIndicators
// (riskIndicatorUtils.ts imports Row the same way).
interface Row {
    type: string;
    name: string;
    riskProfile: Record<string, unknown>;
    // Optional so a caller still on the pre-deploy payload type-checks; the dot falls back to
    // the score path when it is absent.
    riskState?: Record<string, RegulatoryRiskCell>;
}

interface RiskIndicatorCardProps {
    row: Row;
}

const RiskIndicatorCard = ({ row }: RiskIndicatorCardProps) => {
    const { getRiskDot, getRowImage } = useRiskIndicatorStates({
        rows: [],
        setRows: () => {},
        autoFetch: false,
    });
    return (
        <div className={styles.Card}>
            <div className={styles.CardHeader}>
                <span>{getRowImage(row.type)}</span>
                <span>{row.name?.trim() || EMPTY_NAME_PLACEHOLDER}</span>
            </div>
            <div className={styles.CardBody}>
                {RISK_HEADERS.map((header) => (
                    <div key={header.key} className={styles.CardRow}>
                        <span className={styles.MetricName}>{header.label}:</span>
                        <span className={styles.MetricValue}>
                            {' '}
                            {getRiskDot(row.riskProfile[header.key], legalCasesDotState(header.key, row.riskState?.[header.key]))}
                        </span>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default RiskIndicatorCard;
